import { ModalProps } from "../../../helpers/constants";
import { FC } from "react";
import { DataTableColumn } from "../../common/datatable/DataTableTypes";
import { DataTable } from "../../common/datatable/DataTable";
import ButtonTray from "../../common/form/ButtonTray";
import Modal from "../../common/form/Modal";
import { createClickableLink } from "../../common/datatable/DataTableUtils";
import { getProductStatusDotInfo } from "../../../helpers/utils/Utils";
import { useSearchOrdersQuery } from "../../../features/order/ordersApi";

interface props extends ModalProps {
    orderNumber: string,
    setOrderNumber: any
}

const SearchOrderModal: FC<props> = ({ orderNumber, setOrderNumber, show, setShow }) => {


    const columns: DataTableColumn[] = [
        {
            label: "Order No.",
            accessor: "customerOrderNumber",
            overrideSortColumn: "customerOrderNumber",
            cell: (props: any) => {
                const path = `/orders/${props.row.original.id}`;
                const link = createClickableLink(path, props.value, null, false, "", ["ORDR-R", "ORDR-V"]);

                return (
                    <span onClick={() => setShow(false)}>
                        {link}
                    </span>
                );
            },
        },

        {
            label: "Product(s)",
            accessor: "products", // Access the entire 'products' array
            cell: (props: any) => {
                return <>
                    {props.row.original.products.map((product: any) => {
                        const dotInfo = getProductStatusDotInfo(product.productStatus);
                        return (
                            <>
                                <div className="cursor"
                                    onClick={() => window.location.href = "/orders/" + props.row.original.id}>
                                    <i className='product_status_circle fa fa-solid fa-circle'
                                        style={{ color: dotInfo.color }}
                                        title={dotInfo.title}
                                    />
                                    <span>{product.type}</span>
                                </div>
                            </>
                        )
                    })}
                </>
            }
        }

    ]
    return (
        <>
            <Modal title={"Search Order"} show={show} setShow={setShow} className={"w-2/5"}
                fields={
                    <>
                        <DataTable
                            columns={columns}
                            actions={{
                                fetchAction: useSearchOrdersQuery
                            }}
                            defaultFilter={{
                                "customerOrderNumber": orderNumber,
                                pageNumber: 0,
                                pageSize: 8
                            }}
                            renderOptions={{
                                skipUserSettingRender: true
                            }}
                            defaultSortOptions={{
                                accessor: "creationDate",
                                direction: "desc"
                            }}
                            appendFilterToUrl={false}
                        />
                        <ButtonTray
                            buttons={[
                                {
                                    buttonProps: {
                                        btnText: "Cancel",
                                        onClick: () => setShow(false),
                                        type: "close",
                                    },
                                    buttonType: "button"
                                }
                            ]}
                            align={"end"}
                            gap={2}
                        />
                    </>
                }
            />
        </>
    )
}

export default SearchOrderModal;